module.exports = __webpack_public_path__ + "media/svg-new/avatar-15 2-ad8144c6.svg";